<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-user-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ currencyData.id ? 'Editar' : 'Nueva' }} Moneda
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- ISO -->
          <validation-provider
            #default="validationContext"
            name="ISO"
            rules="required"
          >
            <b-form-group
              label="ISO"
              label-for="iso"
            >
              <b-form-input
                id="iso"
                v-model="currencyData.iso"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                class="text-uppercase"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="Moneda"
            rules="required"
          >
            <b-form-group
              label="Moneda"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="currencyData.name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Name -->
          <!-- <validation-provider
            #default="validationContext"
            name="Name"
            rules="required"
          >
            <b-form-group
              label="Name"
              label-for="name"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="currencyData.name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="countriesList"
                :clearable="false"
                input-id="name"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Lang -->
          <!-- <validation-provider
            #default="validationContext"
            name="Language"
            rules="required|alpha-num"
          >
            <b-form-group
              label="Language"
              label-for="lang"
            >
              <b-form-input
                id="lang"
                v-model="currencyData.lang"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->

          <!-- Status -->
          <validation-provider
            name="Activo"
          >
            <b-form-group
              label="Activo"
              label-for="statusCheck"
            >
              <b-form-checkbox
                id="statusCheck"
                v-model="currencyData.status"
                name="statusCheck"
              >
                {{ currencyData.status ? 'Si' : 'No' }}
              </b-form-checkbox>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              :disabled="loading"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <template v-if="loading">
                <b-spinner
                  variant="light"
                  class="mr-75"
                  small
                />
                <span>{{ currencyData.id ? 'Actualizando' : 'Creando' }}</span>
              </template>
              <span v-else>{{ currencyData.id ? 'Actualizar' : 'Crear' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              :disabled="loading"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
// import vSelect from 'vue-select'
import countriesList from '@/@fake-db/data/other/countries'
// import store from '@/store'
import useCurrencies from './useCurrencies'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    BSpinner,
    // vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
      countriesList,
    }
  },
  watch: {
    isAddNewUserSidebarActive(val) {
      if (val && this.item) {
        this.currencyData = {
          id: this.item.id,
          iso: this.item.iso,
          name: this.item.name,
          status: this.item.status,
        }
      } else {
        this.currencyData = {
          id: null,
          iso: '',
          name: '',
          status: true,
        }
        this.$emit('update:item', null)
      }
    },
  },
  setup(_, { emit }) {
    const blankData = {
      id: null,
      iso: '',
      name: '',
      status: true,
    }

    const currencyData = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      currencyData.value = JSON.parse(JSON.stringify(blankData))
    }

    const loading = ref(false)
    const { currencyStore, currencyUpdate } = useCurrencies()

    const onSubmit = async () => {
      loading.value = true

      const data = { ...currencyData.value }
      data.iso = data.iso.toUpperCase()

      try {
        if (data.id) {
          await currencyUpdate(data.id, data)
        } else {
          await currencyStore(data)
        }

        emit('refetchData')
        emit('update:is-add-new-user-sidebar-active', false)
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      currencyData,
      loading,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
